import {
  Box, FormControl, FormLabel, Switch,
} from '@chakra-ui/react';
import useUpdateField from '../useUpdateField';

const CheckboxOptions = ({ field }) => {
  const [allowIndeterminate, setAllowIndeterminate] = useUpdateField(field, 'props.allowIndeterminate', false);

  return (
    <Box>
      <FormControl mt="4" display="flex" alignItems="center">
        <FormLabel fontSize="sm" mb="0">Allow indeterminate</FormLabel>
        <Switch id="email-alerts" isChecked={allowIndeterminate} onChange={(e) => setAllowIndeterminate(e.target.checked)} />
      </FormControl>
    </Box>
  );
};

export default CheckboxOptions;
